export enum PagePositions {
  left = 'left',
  right = 'right'
}
